<form [formGroup]="form" class="flex flex-col gap-4">
  <div class="flex flex-col">
    <span class="soft-label top">Titel</span>
    <soft-ds-input formControlName="title" />
  </div>

  <div class="grid grid-cols-2 gap-4">
    <div class="flex flex-col">
      <span class="soft-label top">Datum</span>
      <soft-ds-date-input formControlName="datum" />
    </div>
    <div class="flex flex-col">
      <span class="soft-label top">
        @if (resourceType() === RosterDeliveryResourceType.Fahrzeug) {
          Fahrzeug
        } @else if (resourceType() === RosterDeliveryResourceType.Vkforg) {
          Vkforg
        } @else {
          Ressource
        }
      </span>
      <soft-ds-input formControlName="resourceName" [readonly]="true" />
    </div>
  </div>

  <div class="grid grid-cols-2 gap-4">
    <div class="flex flex-col">
      <span class="soft-label top">Von</span>
      <soft-ds-time-input formControlName="vonzeit" softFieldValidation />
    </div>
    <div class="flex flex-col">
      <span class="soft-label top">Bis</span>
      <soft-ds-time-input formControlName="biszeit" softFieldValidation />
    </div>
  </div>

  <div class="flex flex-col">
    <span class="soft-label top">Tour-Nummer</span>
    <soft-ds-input formControlName="tour" placeholder="keine Angabe" />
  </div>

  <div class="flex flex-col">
    <span class="soft-label top">Kommentar</span>
    <soft-ds-multiline-input [lines]="3" formControlName="bemerkung" />
  </div>
</form>

<section class="flex justify-end gap-2 mt-4">
  @if (mode() === 'edit') {
    <soft-ds-button variant="destructive" mode="iconOnly" (click)="delete()">
      <soft-ds-icon name="fa-regular fa-trash" />
    </soft-ds-button>
  }
  <soft-ds-button variant="outline" (click)="cancel()">Abbrechen</soft-ds-button>
  <soft-ds-button variant="primary" [disabled]="form.invalid" (click)="save()">
    Speichern
  </soft-ds-button>
</section>
